import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "color", "fontSize", "padding", "paddingBlock", "paddingBlockEnd", "paddingBlockStart", "paddingInline", "paddingInlineEnd", "paddingInlineStart", "margin", "marginBlock", "marginBlockEnd", "marginBlockStart", "marginInline", "marginInlineEnd", "marginInlineStart"];
import { Text } from 'foundations-components/components/Text';
import { useTypographyProps } from './useTypographyProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Heading = _ref => {
  let {
      as = 'h3',
      children,
      color,
      fontSize,
      padding,
      paddingBlock,
      paddingBlockEnd,
      paddingBlockStart,
      paddingInline,
      paddingInlineEnd,
      paddingInlineStart,
      margin,
      marginBlock,
      marginBlockEnd,
      marginBlockStart,
      marginInline,
      marginInlineEnd,
      marginInlineStart
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    typographyProps
  } = useTypographyProps({
    color,
    fontSize,
    isHeading: true,
    padding,
    paddingBlock,
    paddingBlockEnd,
    paddingBlockStart,
    paddingInline,
    paddingInlineEnd,
    paddingInlineStart,
    margin,
    marginBlock,
    marginBlockEnd,
    marginBlockStart,
    marginInline,
    marginInlineEnd,
    marginInlineStart
  });
  return /*#__PURE__*/_jsx(Text, Object.assign({}, rest, {
    as: as
  }, typographyProps, {
    children: children
  }));
};